import Router from "./routers/pageRouter";

const App = () => {
  return (
    <div className="App">
        <Router />
    </div>
  );
}

export default App;